// extracted by mini-css-extract-plugin
export default {"bodyColor":"K","crash":"L","reportId":"M","logo":"N","reportIdGroup":"O","supportInfo":"P"};